import { DynamicPageProps } from '@doltech/routeDefinition';
import { SkillEnum, TestTypeEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';

import { ContentItemProps } from './Content/TableOfContent/TableOfContentType';

export interface LandingLayoutWithSEOHeaderProps extends DynamicPageProps {
  testId: string;
  testType: TestTypeEnum;
  testSkill?: SkillEnum;
  children: any;
  tableOfContentItems?: ContentItemProps[];
  /**
   * accept an array of react nodes
   * example: [
   * <Button1 />,
   * <Button2 />
   * ]
   */
  socials?: React.ReactNodeArray;

  banner?: any;
  bannerLink?: string;
}

export const LandingLayoutWithSEOHeaderContext =
  React.createContext<LandingLayoutWithSEOHeaderProps>(null);
